import { useEffect, useState } from "react";
import { Grid, NumberInput } from "@mantine/core";
import VariableNumberInput from "./VariableNumberInput";

const MAX_INT_32 = 2147483647 // Nodejs Timeout overflow: max: INT32

function Setting(props) {
    const [dataState, setDataState] = useState(props?.nodeData?.data?.options?.nodeSetting ?? {
        fromTimeSleep: 0,
        toTimeSleep: 0
    })

    const handleSelector = (type, value) => {
        if (typeof value === 'string') {
            setDataState({ ...dataState, [type]: value });
        } else if (typeof value === 'object' && value === null) {
            setDataState({ ...dataState, [type]: "" });
        } else {
            setDataState({ ...dataState, [type]: value });
        }
    }

    useEffect(() => {
        props.handleSetDataNodeSetting(dataState)
    }, [props, dataState])

    return (
        <>
            <label className="mantine-InputWrapper-label mantine-Textarea-label mantine-ittua2">
                Sleep time (milliseconds) before running the next node.
            </label>
            <Grid mb='xs'>
                <Grid.Col span={6}>
                    <VariableNumberInput
                        label="From (milliseconds)"
                        placeholder="Enter milliseconds"
                        description="1 s = 1000 ms"
                        name="fromTime"
                        dataState={dataState.fromTimeSleep}
                        handleData={(e) => {
                            handleSelector('fromTimeSleep', e)
                        }}
                    />
                </Grid.Col>
                <Grid.Col span={6}>
                    <VariableNumberInput
                        label="To (milliseconds)"
                        placeholder="Enter milliseconds"
                        description="1 s = 1000 ms"
                        name="toTime"
                        dataState={dataState.toTimeSleep}
                        handleData={(e) => {
                            handleSelector('toTimeSleep', e)
                        }}
                    />
                </Grid.Col>
            </Grid>
        </>
    );
}

export default Setting;